import {
  BFFResponse,
  EmarsysResponse,
} from "@api/endpoint-handlers/bff-functions/Alacrity/utils/types";
import axios from "axios";

const checkUserExists = async (email: string) => {
  const payload = {
    service: "emarsysv2",
    payload: {
      endpoint: "getContactData",
      fields: ["id", 3],
      keyId: "3",
      keyValues: [email],
    },
  };

  const response = await axios.post<BFFResponse<EmarsysResponse>>(
    "/_plat/api/v1/bff",
    payload,
    { timeout: 10000 }
  );

  const data = response.data.body;

  if (!data.success) {
    console.error("getContactData error", data); // eslint-disable-line no-console

    return null;
  }

  return data.data;
};

const createOrUpdateContact = async (payload: {
  payload: Record<string, string | number | boolean>;
  isCreate: boolean;
}): Promise<EmarsysResponse> => {
  const _payload = {
    service: "emarsysv2",
    payload: {
      endpoint: "createOrUpdateContact",
      payload: payload.payload,
      isCreate: payload.isCreate,
    },
  };

  const response = await axios.post<BFFResponse<EmarsysResponse>>(
    "/_plat/api/v1/bff",
    _payload,
    { timeout: 10000 }
  );

  const data = response.data.body;

  if (!data.success) {
    console.error("createOrUpdateContact error", data); // eslint-disable-line no-console
  }

  return data;
};

export const sendDataToEmarsys = async (
  email: string,
  payload: Record<string, string | number | boolean>
): Promise<EmarsysResponse> => {
  const userExists = await checkUserExists(email);

  if (userExists) {
    const payloadToUpdate = {
      payload,
      isCreate: false,
    };

    return await createOrUpdateContact(payloadToUpdate);
  }

  const payloadToCreate = {
    payload,
    isCreate: true,
  };

  return await createOrUpdateContact(payloadToCreate);
};
